export default __webpack_public_path__ + "static/media/black-parcel-measure-icon.99689aec.svg";